<template>
    <div class="ppv2-w-full ppv2-bg-white dark:ppv2-bg-dark ppv2-rounded-xl ppv2-border-dashed border-purple ppv2-p-4">
        <div class="ppv2-flex ppv2-items-center ppv2-justify-between ppv2-mb-3">
            <span class="poppinsSemiBold ppv2-text-black ppv2-text-opacity-70" :style="{ fontSize: normalizeFontSize(14) }">
                {{ $t('forms.type.title') }}
            </span>
            <button
                type="button"
                class="ppv2-w-7 ppv2-h-7 ppv2-rounded-md ppv2-flex ppv2-items-center ppv2-justify-center ppv2-text-black ppv2-text-opacity-90 hover:ppv2-text-black hover:ppv2-text-opacity-100 hover:ppv2-bg-black hover:ppv2-bg-opacity-5 ppv2-transition-colors"
                @click="$emit('close')"
            >
                <FormTypeIcon name="close" :size="15" />
            </button>
        </div>
        <div class="ppv2-grid ppv2-grid-cols-2 md:ppv2-grid-cols-4 ppv2-gap-2">
            <button
                v-for="typeKey in FORM_TYPE_KEYS"
                :key="typeKey"
                type="button"
                class="ppv2-flex ppv2-flex-row ppv2-items-center ppv2-gap-2 ppv2-p-3.5 ppv2-rounded-xl ppv2-border ppv2-border-solid ppv2-border-black ppv2-border-opacity-30 hover:ppv2-border-[#7D2DBD] hover:ppv2-bg-[#7D2DBD]/5 ppv2-transition-colors"
                @click="$emit('select', typeKey)"
            >
                <span
                    class="bg-purple ppv2-bg-opacity-10 text-purple ppv2-shrink-0 ppv2-w-6 ppv2-h-6 ppv2-rounded-[7px] ppv2-flex ppv2-items-center ppv2-justify-center poppinsSemiBold"
                >
                    <FormTypeIcon :name="typeKey" :size="15" />
                </span>
                <span class="poppinsSemiBold ppv2-text-black" :style="{ fontSize: normalizeFontSize(13) }">
                    {{ $t(FORM_TYPES[typeKey].label) }}
                </span>
            </button>
        </div>
    </div>
</template>

<script>
import normalizeFontSize from '../../../../utils/normalizeFontSize'
import FormTypeIcon from './FormTypeIcon.vue'
import { FORM_TYPES, FORM_TYPE_KEYS } from '../formTypes'

export default {
    name: 'FormTypePicker',
    components: { FormTypeIcon },
    data() {
        return {
            FORM_TYPES,
            FORM_TYPE_KEYS,
        }
    },
    methods: {
        normalizeFontSize,
    },
}
</script>
